import { useQuery } from "@tanstack/react-query";
import { useApi } from "hooks/useApi";

export const useFetchCustomers = () => {
  const callApi = useApi();

  return useQuery({
    queryKey: ["customers"],
    queryFn: () => callApi(`/users/customers`),
  });
};

export const useFetchOrganizations = (enabled?: boolean) => {
  const callApi = useApi();

  return useQuery({
    queryKey: ["organizations"],
    queryFn: () => callApi(`/users/organizations`),
    enabled,
  });
};
